// ponytail: brand resolver based on host domain
const isRivas =
  typeof window !== "undefined" &&
  (window.location.hostname.includes("rivas") ||
    window.location.search.includes("tenant=rivas"));

export const tenant = {
  isRivas,
  name: isRivas ? "Rivas" : "Blade",
  fullName: isRivas ? "Rivas" : "Blade",
  logo: (mode) => {
    if (isRivas) {
      return mode === "light"
        ? "/rivas-assets/rivas-logo-negro.svg"
        : "/rivas-assets/rivas-logo-blanco.svg";
    }
    return mode === "light" ? "/logo-negro.svg" : "/logo.svg";
  },
  favicon: isRivas ? "/rivas-assets/favicon.ico" : "/favicon.ico",
  description: isRivas
    ? "Gestioná tu salón de forma simple."
    : "Gestioná tu barbería de forma simple.",
};

export function applyBranding() {
  if (typeof window === "undefined") return;

  // Set title
  document.title = tenant.name;

  // Set description
  const metaDesc = document.querySelector('meta[name="description"]');
  if (metaDesc) {
    metaDesc.setAttribute("content", tenant.description);
  }

  // Update favicons
  const favicons = document.querySelectorAll('link[rel="icon"]');
  favicons.forEach((fav) => {
    if (fav.getAttribute("type") === "image/svg+xml") {
      fav.setAttribute(
        "href",
        tenant.isRivas ? "/rivas-assets/rivas-logo-blanco.svg" : "/logo.svg",
      );
    } else {
      fav.setAttribute("href", tenant.favicon);
    }
  });

  // Apple touch icon
  const appleIcon = document.querySelector('link[rel="apple-touch-icon"]');
  if (appleIcon && tenant.isRivas) {
    appleIcon.setAttribute(
      "href",
      "/rivas-assets/apple-touch-icon-180x180.png",
    );
  }

  // Apple touch startup/splash images
  if (tenant.isRivas) {
    const startupImages = document.querySelectorAll(
      'link[rel="apple-touch-startup-image"]',
    );
    startupImages.forEach((img) => {
      const currentHref = img.getAttribute("href");
      if (currentHref && currentHref.startsWith("/pwa-assets/")) {
        img.setAttribute(
          "href",
          currentHref.replace("/pwa-assets/", "/rivas-assets/"),
        );
      }
    });
  }

  // Update PWA Manifest dynamically
  const manifestEl = document.querySelector('link[rel="manifest"]');
  if (manifestEl && tenant.isRivas) {
    const rivasManifest = {
      id: "/",
      name: "Rivas",
      short_name: "Rivas",
      description: "Gestioná de forma simple.",
      theme_color: "#020817",
      background_color: "#020817",
      display: "standalone",
      icons: [
        {
          src: "/rivas-assets/pwa-64x64.png",
          sizes: "64x64",
          type: "image/png",
        },
        {
          src: "/rivas-assets/pwa-192x192.png",
          sizes: "192x192",
          type: "image/png",
        },
        {
          src: "/rivas-assets/pwa-512x512.png",
          sizes: "512x512",
          type: "image/png",
        },
        {
          src: "/rivas-assets/maskable-icon-512x512.png",
          sizes: "512x512",
          type: "image/png",
          purpose: "maskable",
        },
      ],
    };
    const jsonString = JSON.stringify(rivasManifest);
    const bytes = new TextEncoder().encode(jsonString);
    const binString = Array.from(bytes, (byte) => String.fromCharCode(byte)).join("");
    const base64 = btoa(binString);
    manifestEl.setAttribute("href", `data:application/json;base64,${base64}`);
  }
}
